export const environment = {
    production: false,
    url: "https://uat-tune-api-crm.policystreet.app",
    googleClientId: '922092052954-78n99aorct9vg1i24u5ic2jbc5fmboio.apps.googleusercontent.com',
    cleverTapId: "TEST-4R4-ZK8-557Z",
    o2o: "o2opartners.policystreet.app"
};
